import evidence_file_request_icon from "../../assets/images/task/evidence_file_request.svg";

export const SI4N_TYPES = [
    {
        label: '국민연금',
        id: 'nationalPension',
        shotId : 'nps',
        icon: evidence_file_request_icon
    },
    {
        label: '건강보험',
        id: 'healthInsurance',
        shotId : 'nhis',
        icon: evidence_file_request_icon
    },
    {
        label: '고용보험',
        id: 'employmentInsurance',
        shotId : 'ei',
        icon: evidence_file_request_icon,
        isDev : true,
        disabled: true
    },

    {
        label: '산재보험',
        id: 'industrialAccidentInsurance',
        shotId : 'wia',
        icon: evidence_file_request_icon,
        isDev : true,
        disabled: true
    },
];

export const TEST_TOGETHER_TAX_PAYERS = [{
    "cmpNo": "10437692860",
    "cmpName": "한신빌딩"
},
{
    "cmpNo": "10587416510",
    "cmpName": "주식회사다올시스"
},
{
    "cmpNo": "10587987940",
    "cmpName": "주식회사스탠다드에이"
},
{
    "cmpNo": "10686783390",
    "cmpName": "（주）일등유통"
},
{
    "cmpNo": "10687109040",
    "cmpName": "주식회사다나통상"
},
{
    "cmpNo": "10787545070",
    "cmpName": "（주）알토디자인"
},
{
    "cmpNo": "11293021660",
    "cmpName": "백송이전문점"
},
{
    "cmpNo": "11864004340",
    "cmpName": "더케이(The-K)웨딩컨벤션부페"
},
{
    "cmpNo": "11987050660",
    "cmpName": "（주）옴니텍"
},
{
    "cmpNo": "12386281160",
    "cmpName": "주식회사에스이테크"
},
{
    "cmpNo": "12686798030",
    "cmpName": "주식회사　부광물산"
},
{
    "cmpNo": "12786369040",
    "cmpName": "（주）대성팩"
},
{
    "cmpNo": "12986560410",
    "cmpName": "주식회사여산에프엔비"
},
{
    "cmpNo": "13802310300",
    "cmpName": "훈서비스"
},
{
    "cmpNo": "13813107820",
    "cmpName": "키네스평촌점"
},
{
    "cmpNo": "13881899490",
    "cmpName": "오비스텍주식회사"
},
{
    "cmpNo": "13891411150",
    "cmpName": "한국인성플러스연구소"
},
{
    "cmpNo": "14207254680",
    "cmpName": "신아트엔터테인먼트"
},
{
    "cmpNo": "14281467450",
    "cmpName": "（주）하성"
},
{
    "cmpNo": "14281841090",
    "cmpName": "주식회사명진하우징"
},
{
    "cmpNo": "14481305400",
    "cmpName": "이형종합건설 주식회사"
},
{
    "cmpNo": "15281026090",
    "cmpName": "주식회사웨이브도넛"
},
{
    "cmpNo": "20486203870",
    "cmpName": "（주）이래건축사사무소"
},
{
    "cmpNo": "22010072510",
    "cmpName": "라윤코리아"
},
{
    "cmpNo": "22486020590",
    "cmpName": "주식회사비전메디(VisionMediCo.,Ltd.)"
},
{
    "cmpNo": "22488014280",
    "cmpName": "주식회사플러스씨"
},
{
    "cmpNo": "22881066350",
    "cmpName": "주식회사 유닛랩"
},
{
    "cmpNo": "26181221890",
    "cmpName": "주식회사 시작바이이명순"
},
{
    "cmpNo": "29085004110",
    "cmpName": "단비코리아"
},
{
    "cmpNo": "30386022020",
    "cmpName": "주식회사티미"
},
{
    "cmpNo": "31888022270",
    "cmpName": "주식회사베이지안웍스"
},
{
    "cmpNo": "32988011880",
    "cmpName": "(주)티뮤스토리"
},
{
    "cmpNo": "33486021090",
    "cmpName": "로우리트콜렉티브주식회사"
},
{
    "cmpNo": "35186015560",
    "cmpName": "(주)더블유엔피"
},
{
    "cmpNo": "43686008050",
    "cmpName": "(주)삼에스테크"
},
{
    "cmpNo": "45288001400",
    "cmpName": "주식회사 페이지터너"
},
{
    "cmpNo": "46988008330",
    "cmpName": "주식회사휴웰"
},
{
    "cmpNo": "47687007220",
    "cmpName": "주식회사 알파랩"
},
{
    "cmpNo": "50687027680",
    "cmpName": "주식회사 그리머"
},
{
    "cmpNo": "50688018630",
    "cmpName": "주식회사 파이솔루션"
},
{
    "cmpNo": "50985025690",
    "cmpName": "주식회사 여산에프엔비"
},
{
    "cmpNo": "51885026370",
    "cmpName": "락앤볼1"
},
{
    "cmpNo": "59088009090",
    "cmpName": "태강산업개발(주)"
},
{
    "cmpNo": "60486019210",
    "cmpName": "불가리안로즈코리아주식회사"
},
{
    "cmpNo": "60988000660",
    "cmpName": "주식회사부국물산"
},
{
    "cmpNo": "65786008480",
    "cmpName": "주식회사해움시스템"
},
{
    "cmpNo": "67533012330",
    "cmpName": "미카도스시 영통점"
},
{
    "cmpNo": "67686013430",
    "cmpName": "케이민그룹 주식회사 (KMIN GROUP Corp.)"
},
{
    "cmpNo": "69001025260",
    "cmpName": "엠씨몰더이진점"
},
{
    "cmpNo": "70494002270",
    "cmpName": "신미리샌드아트학원"
},
{
    "cmpNo": "71021007380",
    "cmpName": "베초이(BECHOIS)"
},
{
    "cmpNo": "72999012490",
    "cmpName": "백송이전문점"
},
{
    "cmpNo": "74486015010",
    "cmpName": "주식회사리디아아트앤센트"
},
{
    "cmpNo": "75488015210",
    "cmpName": "엠케이청효주식회사"
},
{
    "cmpNo": "76187025400",
    "cmpName": "노몰로스주식회사"
},
{
    "cmpNo": "77802028800",
    "cmpName": "리휴"
},
{
    "cmpNo": "78181002100",
    "cmpName": "(주)단비코리아"
},
{
    "cmpNo": "81287027560",
    "cmpName": "주식회사올바른생각"
},
{
    "cmpNo": "82388021080",
    "cmpName": "주식회사훈미디어"
},
{
    "cmpNo": "89481011690",
    "cmpName": "제이핏주식회사"
},
{
    "cmpNo": "92022649011",
    "cmpName": "예쁜가방쌈지"
},
{
    "cmpNo": "92229169181",
    "cmpName": "(주)부광물산(PlayZonePC)"
},
{
    "cmpNo": "92336261311",
    "cmpName": "엠씨몰 대야점"
}]

export const TEST_DATA_HEALTH_INSURANCE = {
    "outE0020": {
        "list": []
    },
    "outE0021": {
        "list": []
    },
    "outE0000": {},
    "outE0022": {
        "list": []
    },
    "errMsg": "",
    "outE0001": {
        "list": [
            {
                "no": "1",
                "gojiYyyymm": "2025021",
                "bslcMgmtNo": "31888022270",
                "nabbuNo": "5712161080412",
                "unitFirmSym": "81159124281",
                "gojiChasu": "2025021801",
                "nationFrnanceCd": "00",
                "jungNo": "81159124281",
                "juminNo": "8605091481510",
                "korNm": "김경민",
                "feeMmAmt": "3300000",
                "prodCtrb": "116980",
                "corrCtrb": "0",
                "yendCorrCtrb": "0",
                "hwangubIntr": "0",
                "tMonthCtrb": "116980",
                "corrRsnCd": "",
                "corrRsnNm": "",
                "corrAdptFrYyyymm": "",
                "corrAdptToYyyymm": "",
                "nyProdCtrb": "15140",
                "nyCorrCtrb": "0",
                "nyYendCorrCtrb": "0",
                "nyHwangubIntr": "0",
                "nyTMonthCtrb": "15140",
                "chwidukDt": "20220101",
                "sangsilDt": "99991231",
                "nyCorrRsnCd": "",
                "nyCorrRsnNm": "",
                "nyCorrAdptFrYyyymm": "",
                "nyCorrAdptToYyyymm": ""
            },
            {
                "no": "2",
                "gojiYyyymm": "2025021",
                "bslcMgmtNo": "31888022270",
                "nabbuNo": "5712161080412",
                "unitFirmSym": "81159124372",
                "gojiChasu": "2025021801",
                "nationFrnanceCd": "00",
                "jungNo": "81159124372",
                "juminNo": "8702141481218",
                "korNm": "김장경",
                "feeMmAmt": "9600000",
                "prodCtrb": "340320",
                "corrCtrb": "0",
                "yendCorrCtrb": "0",
                "hwangubIntr": "0",
                "tMonthCtrb": "340320",
                "corrRsnCd": "",
                "corrRsnNm": "",
                "corrAdptFrYyyymm": "",
                "corrAdptToYyyymm": "",
                "nyProdCtrb": "44070",
                "nyCorrCtrb": "0",
                "nyYendCorrCtrb": "0",
                "nyHwangubIntr": "0",
                "nyTMonthCtrb": "44070",
                "chwidukDt": "20220101",
                "sangsilDt": "99991231",
                "nyCorrRsnCd": "",
                "nyCorrRsnNm": "",
                "nyCorrAdptFrYyyymm": "",
                "nyCorrAdptToYyyymm": ""
            },
            {
                "no": "3",
                "gojiYyyymm": "2025021",
                "bslcMgmtNo": "31888022270",
                "nabbuNo": "5712161080412",
                "unitFirmSym": "81159124801",
                "gojiChasu": "2025021801",
                "nationFrnanceCd": "00",
                "jungNo": "81159124801",
                "juminNo": "7910311450723",
                "korNm": "박찬호",
                "feeMmAmt": "6316666",
                "prodCtrb": "223920",
                "corrCtrb": "0",
                "yendCorrCtrb": "0",
                "hwangubIntr": "0",
                "tMonthCtrb": "223920",
                "corrRsnCd": "",
                "corrRsnNm": "",
                "corrAdptFrYyyymm": "",
                "corrAdptToYyyymm": "",
                "nyProdCtrb": "28990",
                "nyCorrCtrb": "0",
                "nyYendCorrCtrb": "0",
                "nyHwangubIntr": "0",
                "nyTMonthCtrb": "28990",
                "chwidukDt": "20220101",
                "sangsilDt": "99991231",
                "nyCorrRsnCd": "",
                "nyCorrRsnNm": "",
                "nyCorrAdptFrYyyymm": "",
                "nyCorrAdptToYyyymm": ""
            },
            {
                "no": "4",
                "gojiYyyymm": "2025021",
                "bslcMgmtNo": "31888022270",
                "nabbuNo": "5712161080412",
                "unitFirmSym": "81159125051",
                "gojiChasu": "2025021801",
                "nationFrnanceCd": "00",
                "jungNo": "81159125051",
                "juminNo": "8808141489110",
                "korNm": "오창현",
                "feeMmAmt": "2400000",
                "prodCtrb": "85080",
                "corrCtrb": "0",
                "yendCorrCtrb": "0",
                "hwangubIntr": "0",
                "tMonthCtrb": "85080",
                "corrRsnCd": "",
                "corrRsnNm": "",
                "corrAdptFrYyyymm": "",
                "corrAdptToYyyymm": "",
                "nyProdCtrb": "11010",
                "nyCorrCtrb": "0",
                "nyYendCorrCtrb": "0",
                "nyHwangubIntr": "0",
                "nyTMonthCtrb": "11010",
                "chwidukDt": "20220101",
                "sangsilDt": "99991231",
                "nyCorrRsnCd": "",
                "nyCorrRsnNm": "",
                "nyCorrAdptFrYyyymm": "",
                "nyCorrAdptToYyyymm": ""
            },
            {
                "no": "5",
                "gojiYyyymm": "2025021",
                "bslcMgmtNo": "31888022270",
                "nabbuNo": "5712161080412",
                "unitFirmSym": "81159125138",
                "gojiChasu": "2025021801",
                "nationFrnanceCd": "00",
                "jungNo": "81159125138",
                "juminNo": "7601121011813",
                "korNm": "육지문",
                "feeMmAmt": "7650000",
                "prodCtrb": "271190",
                "corrCtrb": "0",
                "yendCorrCtrb": "0",
                "hwangubIntr": "0",
                "tMonthCtrb": "271190",
                "corrRsnCd": "",
                "corrRsnNm": "",
                "corrAdptFrYyyymm": "",
                "corrAdptToYyyymm": "",
                "nyProdCtrb": "35120",
                "nyCorrCtrb": "-10540",
                "nyYendCorrCtrb": "0",
                "nyHwangubIntr": "0",
                "nyTMonthCtrb": "14040",
                "chwidukDt": "20220101",
                "sangsilDt": "99991231",
                "nyCorrRsnCd": "",
                "nyCorrRsnNm": "장기요양보험료반환",
                "nyCorrAdptFrYyyymm": "202501",
                "nyCorrAdptToYyyymm": "202501"
            },
            {
                "no": "6",
                "gojiYyyymm": "2025021",
                "bslcMgmtNo": "31888022270",
                "nabbuNo": "5712161080412",
                "unitFirmSym": "81159125138",
                "gojiChasu": "2025021801",
                "nationFrnanceCd": "00",
                "jungNo": "81159125138",
                "juminNo": "7601121011813",
                "korNm": "육지문",
                "feeMmAmt": "7650000",
                "prodCtrb": "0",
                "corrCtrb": "0",
                "yendCorrCtrb": "0",
                "hwangubIntr": "0",
                "tMonthCtrb": "0",
                "corrRsnCd": "",
                "corrRsnNm": "",
                "corrAdptFrYyyymm": "",
                "corrAdptToYyyymm": "",
                "nyProdCtrb": "0",
                "nyCorrCtrb": "-10540",
                "nyYendCorrCtrb": "0",
                "nyHwangubIntr": "0",
                "nyTMonthCtrb": "0",
                "chwidukDt": "20220101",
                "sangsilDt": "99991231",
                "nyCorrRsnCd": "",
                "nyCorrRsnNm": "당월경감",
                "nyCorrAdptFrYyyymm": "",
                "nyCorrAdptToYyyymm": ""
            },
            {
                "no": "7",
                "gojiYyyymm": "2025021",
                "bslcMgmtNo": "31888022270",
                "nabbuNo": "5712161080412",
                "unitFirmSym": "81159125241",
                "gojiChasu": "2025021801",
                "nationFrnanceCd": "00",
                "jungNo": "81159125241",
                "juminNo": "8003311120518",
                "korNm": "장상민",
                "feeMmAmt": "4300000",
                "prodCtrb": "152430",
                "corrCtrb": "0",
                "yendCorrCtrb": "0",
                "hwangubIntr": "0",
                "tMonthCtrb": "152430",
                "corrRsnCd": "",
                "corrRsnNm": "",
                "corrAdptFrYyyymm": "",
                "corrAdptToYyyymm": "",
                "nyProdCtrb": "19740",
                "nyCorrCtrb": "0",
                "nyYendCorrCtrb": "0",
                "nyHwangubIntr": "0",
                "nyTMonthCtrb": "19740",
                "chwidukDt": "20220101",
                "sangsilDt": "99991231",
                "nyCorrRsnCd": "",
                "nyCorrRsnNm": "",
                "nyCorrAdptFrYyyymm": "",
                "nyCorrAdptToYyyymm": ""
            },
            {
                "no": "8",
                "gojiYyyymm": "2025021",
                "bslcMgmtNo": "31888022270",
                "nabbuNo": "5712161080412",
                "unitFirmSym": "81159125332",
                "gojiChasu": "2025021801",
                "nationFrnanceCd": "00",
                "jungNo": "81159125332",
                "juminNo": "9108042018129",
                "korNm": "주희",
                "feeMmAmt": "3200000",
                "prodCtrb": "113440",
                "corrCtrb": "0",
                "yendCorrCtrb": "0",
                "hwangubIntr": "0",
                "tMonthCtrb": "113440",
                "corrRsnCd": "",
                "corrRsnNm": "",
                "corrAdptFrYyyymm": "",
                "corrAdptToYyyymm": "",
                "nyProdCtrb": "14690",
                "nyCorrCtrb": "0",
                "nyYendCorrCtrb": "0",
                "nyHwangubIntr": "0",
                "nyTMonthCtrb": "14690",
                "chwidukDt": "20220101",
                "sangsilDt": "99991231",
                "nyCorrRsnCd": "",
                "nyCorrRsnNm": "",
                "nyCorrAdptFrYyyymm": "",
                "nyCorrAdptToYyyymm": ""
            },
            {
                "no": "9",
                "gojiYyyymm": "2025021",
                "bslcMgmtNo": "31888022270",
                "nabbuNo": "5712161080412",
                "unitFirmSym": "81242268861",
                "gojiChasu": "2025021801",
                "nationFrnanceCd": "00",
                "jungNo": "81242268861",
                "juminNo": "8906065640191",
                "korNm": "강톨가",
                "feeMmAmt": "2000000",
                "prodCtrb": "70900",
                "corrCtrb": "0",
                "yendCorrCtrb": "0",
                "hwangubIntr": "0",
                "tMonthCtrb": "70900",
                "corrRsnCd": "",
                "corrRsnNm": "",
                "corrAdptFrYyyymm": "",
                "corrAdptToYyyymm": "",
                "nyProdCtrb": "9180",
                "nyCorrCtrb": "0",
                "nyYendCorrCtrb": "0",
                "nyHwangubIntr": "0",
                "nyTMonthCtrb": "9180",
                "chwidukDt": "20221001",
                "sangsilDt": "99991231",
                "nyCorrRsnCd": "",
                "nyCorrRsnNm": "",
                "nyCorrAdptFrYyyymm": "",
                "nyCorrAdptToYyyymm": ""
            },
            {
                "no": "10",
                "gojiYyyymm": "2025021",
                "bslcMgmtNo": "31888022270",
                "nabbuNo": "5712161080412",
                "unitFirmSym": "81315949116",
                "gojiChasu": "2025021801",
                "nationFrnanceCd": "00",
                "jungNo": "81315949116",
                "juminNo": "8901305260397",
                "korNm": "오랑치맥솜야",
                "feeMmAmt": "4300000",
                "prodCtrb": "152430",
                "corrCtrb": "0",
                "yendCorrCtrb": "0",
                "hwangubIntr": "0",
                "tMonthCtrb": "152430",
                "corrRsnCd": "",
                "corrRsnNm": "",
                "corrAdptFrYyyymm": "",
                "corrAdptToYyyymm": "",
                "nyProdCtrb": "19740",
                "nyCorrCtrb": "0",
                "nyYendCorrCtrb": "0",
                "nyHwangubIntr": "0",
                "nyTMonthCtrb": "19740",
                "chwidukDt": "20230601",
                "sangsilDt": "99991231",
                "nyCorrRsnCd": "",
                "nyCorrRsnNm": "",
                "nyCorrAdptFrYyyymm": "",
                "nyCorrAdptToYyyymm": ""
            },
            {
                "no": "11",
                "gojiYyyymm": "2025021",
                "bslcMgmtNo": "31888022270",
                "nabbuNo": "5712161080412",
                "unitFirmSym": "81336437829",
                "gojiChasu": "2025021801",
                "nationFrnanceCd": "00",
                "jungNo": "81336437829",
                "juminNo": "9505042079112",
                "korNm": "목지윤",
                "feeMmAmt": "4000000",
                "prodCtrb": "141800",
                "corrCtrb": "0",
                "yendCorrCtrb": "0",
                "hwangubIntr": "0",
                "tMonthCtrb": "141800",
                "corrRsnCd": "",
                "corrRsnNm": "",
                "corrAdptFrYyyymm": "",
                "corrAdptToYyyymm": "",
                "nyProdCtrb": "18360",
                "nyCorrCtrb": "0",
                "nyYendCorrCtrb": "0",
                "nyHwangubIntr": "0",
                "nyTMonthCtrb": "18360",
                "chwidukDt": "20230801",
                "sangsilDt": "99991231",
                "nyCorrRsnCd": "",
                "nyCorrRsnNm": "",
                "nyCorrAdptFrYyyymm": "",
                "nyCorrAdptToYyyymm": ""
            },
            {
                "no": "12",
                "gojiYyyymm": "2025021",
                "bslcMgmtNo": "31888022270",
                "nabbuNo": "5712161080412",
                "unitFirmSym": "81359970209",
                "gojiChasu": "2025021801",
                "nationFrnanceCd": "00",
                "jungNo": "81359970209",
                "juminNo": "8610202199316",
                "korNm": "김보라",
                "feeMmAmt": "2000000",
                "prodCtrb": "0",
                "corrCtrb": "0",
                "yendCorrCtrb": "0",
                "hwangubIntr": "0",
                "tMonthCtrb": "0",
                "corrRsnCd": "",
                "corrRsnNm": "",
                "corrAdptFrYyyymm": "",
                "corrAdptToYyyymm": "",
                "nyProdCtrb": "0",
                "nyCorrCtrb": "0",
                "nyYendCorrCtrb": "0",
                "nyHwangubIntr": "0",
                "nyTMonthCtrb": "0",
                "chwidukDt": "20231101",
                "sangsilDt": "99991231",
                "nyCorrRsnCd": "",
                "nyCorrRsnNm": "",
                "nyCorrAdptFrYyyymm": "",
                "nyCorrAdptToYyyymm": ""
            },
            {
                "no": "13",
                "gojiYyyymm": "2025021",
                "bslcMgmtNo": "31888022270",
                "nabbuNo": "5712161080412",
                "unitFirmSym": "81423579092",
                "gojiChasu": "2025021801",
                "nationFrnanceCd": "00",
                "jungNo": "81423579092",
                "juminNo": "9902051953817",
                "korNm": "송승훈",
                "feeMmAmt": "2100000",
                "prodCtrb": "74440",
                "corrCtrb": "0",
                "yendCorrCtrb": "0",
                "hwangubIntr": "0",
                "tMonthCtrb": "74440",
                "corrRsnCd": "",
                "corrRsnNm": "",
                "corrAdptFrYyyymm": "",
                "corrAdptToYyyymm": "",
                "nyProdCtrb": "9640",
                "nyCorrCtrb": "0",
                "nyYendCorrCtrb": "0",
                "nyHwangubIntr": "0",
                "nyTMonthCtrb": "9640",
                "chwidukDt": "20240601",
                "sangsilDt": "99991231",
                "nyCorrRsnCd": "",
                "nyCorrRsnNm": "",
                "nyCorrAdptFrYyyymm": "",
                "nyCorrAdptToYyyymm": ""
            },
            {
                "no": "14",
                "gojiYyyymm": "2025021",
                "bslcMgmtNo": "31888022270",
                "nabbuNo": "5712161080412",
                "unitFirmSym": "81423579179",
                "gojiChasu": "2025021801",
                "nationFrnanceCd": "00",
                "jungNo": "81423579179",
                "juminNo": "8806172932110",
                "korNm": "양영아",
                "feeMmAmt": "2100000",
                "prodCtrb": "74440",
                "corrCtrb": "0",
                "yendCorrCtrb": "0",
                "hwangubIntr": "0",
                "tMonthCtrb": "74440",
                "corrRsnCd": "",
                "corrRsnNm": "",
                "corrAdptFrYyyymm": "",
                "corrAdptToYyyymm": "",
                "nyProdCtrb": "9640",
                "nyCorrCtrb": "0",
                "nyYendCorrCtrb": "0",
                "nyHwangubIntr": "0",
                "nyTMonthCtrb": "9640",
                "chwidukDt": "20240601",
                "sangsilDt": "99991231",
                "nyCorrRsnCd": "",
                "nyCorrRsnNm": "",
                "nyCorrAdptFrYyyymm": "",
                "nyCorrAdptToYyyymm": ""
            },
            {
                "no": "15",
                "gojiYyyymm": "2025021",
                "bslcMgmtNo": "31888022270",
                "nabbuNo": "5712161080412",
                "unitFirmSym": "81423579234",
                "gojiChasu": "2025021801",
                "nationFrnanceCd": "00",
                "jungNo": "81423579234",
                "juminNo": "7710292067413",
                "korNm": "우원경",
                "feeMmAmt": "2100000",
                "prodCtrb": "74440",
                "corrCtrb": "0",
                "yendCorrCtrb": "0",
                "hwangubIntr": "0",
                "tMonthCtrb": "74440",
                "corrRsnCd": "",
                "corrRsnNm": "",
                "corrAdptFrYyyymm": "",
                "corrAdptToYyyymm": "",
                "nyProdCtrb": "9640",
                "nyCorrCtrb": "0",
                "nyYendCorrCtrb": "0",
                "nyHwangubIntr": "0",
                "nyTMonthCtrb": "9640",
                "chwidukDt": "20240601",
                "sangsilDt": "99991231",
                "nyCorrRsnCd": "",
                "nyCorrRsnNm": "",
                "nyCorrAdptFrYyyymm": "",
                "nyCorrAdptToYyyymm": ""
            },
            {
                "no": "16",
                "gojiYyyymm": "2025021",
                "bslcMgmtNo": "31888022270",
                "nabbuNo": "5712161080412",
                "unitFirmSym": "81445625253",
                "gojiChasu": "2025021801",
                "nationFrnanceCd": "00",
                "jungNo": "81445625253",
                "juminNo": "9501111177514",
                "korNm": "양지석",
                "feeMmAmt": "2400000",
                "prodCtrb": "85080",
                "corrCtrb": "0",
                "yendCorrCtrb": "0",
                "hwangubIntr": "0",
                "tMonthCtrb": "85080",
                "corrRsnCd": "",
                "corrRsnNm": "",
                "corrAdptFrYyyymm": "",
                "corrAdptToYyyymm": "",
                "nyProdCtrb": "11010",
                "nyCorrCtrb": "0",
                "nyYendCorrCtrb": "0",
                "nyHwangubIntr": "0",
                "nyTMonthCtrb": "11010",
                "chwidukDt": "20240801",
                "sangsilDt": "99991231",
                "nyCorrRsnCd": "",
                "nyCorrRsnNm": "",
                "nyCorrAdptFrYyyymm": "",
                "nyCorrAdptToYyyymm": ""
            }
        ],
        "errYn": "N",
        "errMsg": ""
    },
    "outE0023": {
        "list": []
    },
    "outE0002": {
        "list": []
    },
    "resMsg": "",
    "uid": "",
    "resCd": "0000",
    "errYn": "N",
    "txaaYn": "Y",
    "outE1021": {
        "list": []
    },
    "in": {
        "signName": "세무법인 함께2",
        "loginId": "78885030790",
        "loginMethod": "CERT",
        "appCd": "yds",
        "svcCd": "E0001",
        "thread_id": "bb022bea-671c-4a00-baa0-76f40832d7e1",
        "loginCheckType": 3,
        "orgCd": "edi.4insure",
        "signExpired": "2025-12-05",
        "mgmtNo": "31888022270",
        "yyyyMM": "202502",
        "engVer": "V2",
        "firmSym": "79135900",
        "unitFirmSym": "000",
        "fromDate": "20250201",
        "toDate": "20250315"
    },
    "outE0010": {
        "list": []
    },
    "biz_info": {
        "bizNo": "3188802227",
        "bizNm": "주식회사베이지안웍스",
        "mgmtNo": "31888022270"
    },
    "outE0011": {
        "list": []
    },
    "outE1022": {
        "list": []
    },
    "appCd": "yds",
    "outE1002": {
        "list": []
    },
    "svcCd": "E0001",
    "connCnt": "14",
    "orgCd": "edi.4insure",
    "device": "Windows",
    "outTime": "Wed Feb 19 2025 06:34:43 GMT+0900"
}

export const TEST_DATA_NATIONAL_PENSION = {
    "outE0020": {
        "list": []
    },
    "outE0021": {
        "list": [],
        "errYn": "N",
        "errMsg": "조회 내역이 없습니다.",
        "issYm": "202411",
        "tsmsDt": "20241119",
        "docNo": "20241119-124528-750240",
        "fmNm": "(2024.11월) 국민연금보험료 결정내역 통보서(2차)"
    },
    "outE0000": {},
    "outE0022": {
        "list": [],
        "errYn": "N",
        "errMsg": "조회 내역이 없습니다.",
        "issYm": "202411",
        "tsmsDt": "20241119",
        "docNo": "20241119-124528-750240",
        "fmNm": "(2024.11월) 국민연금보험료 결정내역 통보서(2차)"
    },
    "errMsg": "",
    "outE0001": {
        "list": []
    },
    "outE0023": {
        "list": []
    },
    "outE0002": {
        "list": [
            {
                "no": "1",
                "privInsName": "강톨가",
                "privInsRrno": "8906065640191",
                "privInsStndIncmMthAmt": "1972000",
                "privInsMthIns": "177480",
                "privInsEmplPay": "88740",
                "privInsPrsnPay": "88740",
                "gookprivInsEmplPay": "",
                "gookprivInsPrsnPay": ""
            },
            {
                "no": "2",
                "privInsName": "김경민",
                "privInsRrno": "8605091481510",
                "privInsStndIncmMthAmt": "3254000",
                "privInsMthIns": "292860",
                "privInsEmplPay": "146430",
                "privInsPrsnPay": "146430",
                "gookprivInsEmplPay": "",
                "gookprivInsPrsnPay": ""
            },
            {
                "no": "3",
                "privInsName": "김장경",
                "privInsRrno": "8702141481218",
                "privInsStndIncmMthAmt": "6170000",
                "privInsMthIns": "555300",
                "privInsEmplPay": "277650",
                "privInsPrsnPay": "277650",
                "gookprivInsEmplPay": "",
                "gookprivInsPrsnPay": ""
            },
            {
                "no": "4",
                "privInsName": "목지윤",
                "privInsRrno": "9505042079112",
                "privInsStndIncmMthAmt": "3921000",
                "privInsMthIns": "352880",
                "privInsEmplPay": "176440",
                "privInsPrsnPay": "176440",
                "gookprivInsEmplPay": "",
                "gookprivInsPrsnPay": ""
            },
            {
                "no": "5",
                "privInsName": "박찬호",
                "privInsRrno": "7910311450723",
                "privInsStndIncmMthAmt": "6170000",
                "privInsMthIns": "555300",
                "privInsEmplPay": "277650",
                "privInsPrsnPay": "277650",
                "gookprivInsEmplPay": "",
                "gookprivInsPrsnPay": ""
            },
            {
                "no": "6",
                "privInsName": "송승훈",
                "privInsRrno": "9902051953817",
                "privInsStndIncmMthAmt": "2100000",
                "privInsMthIns": "189000",
                "privInsEmplPay": "94500",
                "privInsPrsnPay": "94500",
                "gookprivInsEmplPay": "",
                "gookprivInsPrsnPay": ""
            },
            {
                "no": "7",
                "privInsName": "양영아",
                "privInsRrno": "8806172932110",
                "privInsStndIncmMthAmt": "2100000",
                "privInsMthIns": "189000",
                "privInsEmplPay": "94500",
                "privInsPrsnPay": "94500",
                "gookprivInsEmplPay": "",
                "gookprivInsPrsnPay": ""
            },
            {
                "no": "8",
                "privInsName": "양지석",
                "privInsRrno": "9501111177514",
                "privInsStndIncmMthAmt": "2400000",
                "privInsMthIns": "216000",
                "privInsEmplPay": "108000",
                "privInsPrsnPay": "108000",
                "gookprivInsEmplPay": "",
                "gookprivInsPrsnPay": ""
            },
            {
                "no": "9",
                "privInsName": "오창현",
                "privInsRrno": "8808141489110",
                "privInsStndIncmMthAmt": "2367000",
                "privInsMthIns": "213020",
                "privInsEmplPay": "106510",
                "privInsPrsnPay": "106510",
                "gookprivInsEmplPay": "",
                "gookprivInsPrsnPay": ""
            },
            {
                "no": "10",
                "privInsName": "우원경",
                "privInsRrno": "7710292067413",
                "privInsStndIncmMthAmt": "2100000",
                "privInsMthIns": "189000",
                "privInsEmplPay": "94500",
                "privInsPrsnPay": "94500",
                "gookprivInsEmplPay": "",
                "gookprivInsPrsnPay": ""
            },
            {
                "no": "11",
                "privInsName": "육지문",
                "privInsRrno": "7601121011813",
                "privInsStndIncmMthAmt": "5462000",
                "privInsMthIns": "491580",
                "privInsEmplPay": "245790",
                "privInsPrsnPay": "245790",
                "gookprivInsEmplPay": "",
                "gookprivInsPrsnPay": ""
            },
            {
                "no": "12",
                "privInsName": "장상민",
                "privInsRrno": "8003311120518",
                "privInsStndIncmMthAmt": "4241000",
                "privInsMthIns": "381680",
                "privInsEmplPay": "190840",
                "privInsPrsnPay": "190840",
                "gookprivInsEmplPay": "",
                "gookprivInsPrsnPay": ""
            },
            {
                "no": "13",
                "privInsName": "주희",
                "privInsRrno": "9108042018129",
                "privInsStndIncmMthAmt": "3156000",
                "privInsMthIns": "284040",
                "privInsEmplPay": "142020",
                "privInsPrsnPay": "142020",
                "gookprivInsEmplPay": "",
                "gookprivInsPrsnPay": ""
            }
        ],
        "errYn": "N",
        "errMsg": "",
        "sPrsnCnt": "13",
        "sAmt": "4087140",
        "sIncrease": "",
        "sPartition": "02",
        "sRcpIns": "",
        "sSplInterest": "",
        "sEmlReduc": "200",
        "sNtsrSbsamDdctAmt": "",
        "sBfmmNtsrSbsdAppAmt": "",
        "sCrfwNtsrSbsdAppAmt": "",
        "sBlc": "",
        "sPay": "4086940",
        "ePrsnCnt": "13",
        "eAmt": "4087140",
        "eIncrease": "",
        "ePartition": "02",
        "eRcpIns": "",
        "eSplInterest": "",
        "eEmlReduc": "200",
        "eNtsrSbsamDdctAmt": "",
        "eBfmmNtsrSbsdAppAmt": "",
        "eCrfwNtsrSbsdAppAmt": "",
        "eBlc": "",
        "ePay": "4086940",
        "issYm": "202411",
        "tsmsDt": "20241119",
        "docNo": "20241119-124528-750240",
        "fmNm": "(2024.11월) 국민연금보험료 결정내역 통보서(2차)"
    },
    "resMsg": "",
    "uid": "",
    "resCd": "0000",
    "errYn": "N",
    "txaaYn": "",
    "outE1021": {
        "list": []
    },
    "in": {
        "loginId": "78885030790",
        "loginMethod": "CERT",
        "appCd": "yds",
        "svcCd": "E2222",
        "thread_id": "b9a7f287-2af3-4356-8c6e-69b6753379fc",
        "loginCheckType": 3,
        "orgCd": "edi.4insure",
        "idx": 1238,
        "mgmtNo": "31888022270",
        "yyyyMM": "202411",
        "engVer": "V2",
        "fromDate": "20241101",
        "toDate": "20241215"
    },
    "outE0010": {
        "list": []
    },
    "biz_info": {
        "bizNo": "3188802227",
        "bizNm": "주식회사베이지안웍스",
        "mgmtNo": "31888022270"
    },
    "outE0011": {
        "list": []
    },
    "outE1022": {
        "list": []
    },
    "appCd": "yds",
    "outE1002": {
        "list": []
    },
    "svcCd": "E2222",
    "connCnt": "24",
    "orgCd": "edi.4insure",
    "device": "Windows",
    "outTime": "Wed Feb 19 2025 04:48:34 GMT+0900"
}

export const TEST_TAX_PAYER_LIST = [
    {
        "fileIdxes": [],
        "type": [
            "bookKeeping",
            "accountingSupport"
        ],
        "idx": 7504,
        "companyIdx": 100002,
        "careCompanyIdx": 100043,
        "isUse": true,
        "txprNm": "주식회사 스탠다드에이",
        "rprsTxprNm": "류윤하",
        "pfbEml": null,
        "taPrxClntClCd": null,
        "txprStatNm": null,
        "bsno": "1058798794",
        "ofbDt": null,
        "cfbDt": null,
        "resno": "1058798794",
        "roadAdr": null,
        "ldAdr": null,
        "telno": null,
        "mpno": null,
        "mpInfrRcvnAgrYn": null,
        "infrRcvnAgrYn": null,
        "afaDt": "2021-11-23T00:00:00.000Z",
        "dsmsDt": null,
        "txaaDsmsRsnNm": null,
        "afaInfrOfrAgrClCd": null,
        "afaInfrOfrAgrClNm": null,
        "infrOfrRngCd": null,
        "infrOfrRngNm": null,
        "tfbCd": null,
        "bcNm": null,
        "itmNm": null,
        "cshptJnnYn": null,
        "crdcJnnYn": null,
        "whtxDutyClNm": null,
        "whlPmtBmanYn": null,
        "abftChrgTxhfOgzNm": null,
        "agent": null,
        "agrDt": "2021-12-02T00:00:00.000Z",
        "companyStatus": "",
        "ceoName": "류윤하",
        "companyName": "주식회사 스탠다드에이",
        "email": "",
        "businessType": "",
        "openDate": null,
        "closeDate": null,
        "rgeNum": null,
        "address": ",",
        "tel": "",
        "mobile": "",
        "startDate": "2021-11-23T00:00:00.000Z",
        "expiredDate": null,
        "expiredType": "",
        "reason": null,
        "industryStCode": "",
        "industryType": "",
        "industrySect": "",
        "cashAffiliate": "",
        "cardAffiliate": "",
        "withholdingTaxDivision": "",
        "isVat": "",
        "taxOffice": "",
        "taxManager": "",
        "isScraping": true,
        "memo": "",
        "createdTime": "2024-01-09T07:37:37.672Z",
        "updatedTime": "2024-05-15T06:14:51.954Z",
        "deletedTime": null,
        "companyToTaxpayer": {
            "idx": 612,
            "companyIdx": 100043,
            "taxpayerIdx": 7504,
            "createdTime": "2024-05-15T06:14:51.958Z",
            "updatedTime": "2024-05-15T06:14:51.000Z"
        },
        "taxpayerManagerEmployees": [
            {
                "idx": 3,
                "name": "최영우",
                "code": "10001",
                "companyIdx": 100002,
                "companyManagerPerson": {
                    "idx": 14161,
                    "companyIdx": 100043,
                    "taxpayerIdx": 7504,
                    "companyManagerIdx": 3008,
                    "level": 1,
                    "managerIdx": 3,
                    "createdTime": "2024-04-11T06:24:01.000Z",
                    "updatedTime": "2024-04-11T06:24:01.000Z",
                    "deletedTime": null
                }
            },
            {
                "idx": 9,
                "name": "서은주",
                "code": "80001",
                "companyIdx": 100002,
                "companyManagerPerson": {
                    "idx": 14162,
                    "companyIdx": 100043,
                    "taxpayerIdx": 7504,
                    "companyManagerIdx": 3008,
                    "level": 1,
                    "managerIdx": 9,
                    "createdTime": "2024-04-11T06:24:01.000Z",
                    "updatedTime": "2024-04-11T06:24:01.000Z",
                    "deletedTime": null
                }
            },
            {
                "idx": 6,
                "name": "이윤희",
                "code": "70001",
                "companyIdx": 100002,
                "companyManagerPerson": {
                    "idx": 14163,
                    "companyIdx": 100043,
                    "taxpayerIdx": 7504,
                    "companyManagerIdx": 3008,
                    "level": 2,
                    "managerIdx": 6,
                    "createdTime": "2024-04-11T06:24:01.000Z",
                    "updatedTime": "2024-04-11T06:24:01.000Z",
                    "deletedTime": null
                }
            },
            {
                "idx": 401,
                "name": "황선엽",
                "code": "80012",
                "companyIdx": 100002,
                "companyManagerPerson": {
                    "idx": 14164,
                    "companyIdx": 100043,
                    "taxpayerIdx": 7504,
                    "companyManagerIdx": 3008,
                    "level": 2,
                    "managerIdx": 401,
                    "createdTime": "2024-04-11T06:24:01.000Z",
                    "updatedTime": "2024-04-11T06:24:01.000Z",
                    "deletedTime": null
                }
            },
            {
                "idx": 512,
                "name": "유혜인",
                "code": "80013",
                "companyIdx": 100002,
                "companyManagerPerson": {
                    "idx": 14165,
                    "companyIdx": 100043,
                    "taxpayerIdx": 7504,
                    "companyManagerIdx": 3008,
                    "level": 2,
                    "managerIdx": 512,
                    "createdTime": "2024-04-11T06:24:01.000Z",
                    "updatedTime": "2024-04-11T06:24:01.000Z",
                    "deletedTime": null
                }
            }
        ]
    }, {
        "fileIdxes": null,
        "type": [
            "bookKeeping"
        ],
        "idx": 7562,
        "companyIdx": 100002,
        "careCompanyIdx": null,
        "isUse": true,
        "txprNm": "페이브",
        "rprsTxprNm": "김재환",
        "pfbEml": "kimjh091@gmail.com",
        "taPrxClntClCd": "개인사업자",
        "txprStatNm": "계속사업자",
        "bsno": "6892000757",
        "ofbDt": "2018-08-13T00:00:00.000Z",
        "cfbDt": null,
        "resno": "870110*******",
        "roadAdr": "서울특별시 송파구 성내천로35길 5, 가동 305호(마천동, 메리트연립)",
        "ldAdr": "서울특별시 송파구 마천동 159-217 메리트연립 가동 305호 ",
        "telno": "010 8661****",
        "mpno": "010 8661****",
        "mpInfrRcvnAgrYn": "N",
        "infrRcvnAgrYn": "Y",
        "afaDt": "2020-11-04T00:00:00.000Z",
        "dsmsDt": null,
        "txaaDsmsRsnNm": "해당없음",
        "afaInfrOfrAgrClCd": "01",
        "afaInfrOfrAgrClNm": "동의",
        "infrOfrRngCd": "02",
        "infrOfrRngNm": "타소득포함",
        "tfbCd": "722005",
        "bcNm": "서비스업",
        "itmNm": "소프트웨어 개발 자문 및 제작",
        "cshptJnnYn": "Y",
        "crdcJnnYn": "N",
        "whtxDutyClNm": "월납",
        "whlPmtBmanYn": "N",
        "abftChrgTxhfOgzNm": "송파",
        "agent": "노혜림(T.02-2224-9289)",
        "agrDt": "2020-11-05T00:00:00.000Z",
        "companyStatus": "계속사업자",
        "ceoName": "김재환",
        "companyName": "페이브",
        "email": "kimjh091@gmail.com",
        "businessType": "개인사업자",
        "openDate": "2018-08-13T00:00:00.000Z",
        "closeDate": null,
        "rgeNum": "870110*******",
        "address": "서울특별시 송파구 성내천로35길 5, 가동 305호(마천동, 메리트연립)",
        "tel": "010 8661****",
        "mobile": "010 8661****",
        "startDate": "2020-11-04T00:00:00.000Z",
        "expiredDate": null,
        "expiredType": null,
        "reason": "해당없음",
        "industryStCode": "722005",
        "industryType": "서비스업",
        "industrySect": "소프트웨어 개발 자문 및 제작",
        "cashAffiliate": "Y",
        "cardAffiliate": "N",
        "withholdingTaxDivision": "월납",
        "isVat": "N",
        "taxOffice": "송파",
        "taxManager": "노혜림(T.02-2224-9289)",
        "isScraping": true,
        "memo": null,
        "createdTime": "2024-01-09T07:37:37.672Z",
        "updatedTime": "2024-01-09T07:37:37.851Z",
        "deletedTime": null,
        "companyToTaxpayer": null,
        "taxpayerManagerEmployees": [
            {
                "idx": 3,
                "name": "최영우",
                "code": "10001",
                "companyIdx": 100002,
                "companyManagerPerson": {
                    "idx": 15053,
                    "companyIdx": null,
                    "taxpayerIdx": 7562,
                    "companyManagerIdx": 3161,
                    "level": 1,
                    "managerIdx": 3,
                    "createdTime": "2024-04-11T06:33:54.000Z",
                    "updatedTime": "2024-04-11T06:33:54.000Z",
                    "deletedTime": null
                }
            },
            {
                "idx": 6,
                "name": "이윤희",
                "code": "70001",
                "companyIdx": 100002,
                "companyManagerPerson": {
                    "idx": 15054,
                    "companyIdx": null,
                    "taxpayerIdx": 7562,
                    "companyManagerIdx": 3161,
                    "level": 2,
                    "managerIdx": 6,
                    "createdTime": "2024-04-11T06:33:54.000Z",
                    "updatedTime": "2024-04-11T06:33:54.000Z",
                    "deletedTime": null
                }
            },
            {
                "idx": 9,
                "name": "서은주",
                "code": "80001",
                "companyIdx": 100002,
                "companyManagerPerson": {
                    "idx": 15055,
                    "companyIdx": null,
                    "taxpayerIdx": 7562,
                    "companyManagerIdx": 3161,
                    "level": 1,
                    "managerIdx": 9,
                    "createdTime": "2024-04-11T06:33:54.000Z",
                    "updatedTime": "2024-04-11T06:33:54.000Z",
                    "deletedTime": null
                }
            },
            {
                "idx": 401,
                "name": "황선엽",
                "code": "80012",
                "companyIdx": 100002,
                "companyManagerPerson": {
                    "idx": 15056,
                    "companyIdx": null,
                    "taxpayerIdx": 7562,
                    "companyManagerIdx": 3161,
                    "level": 2,
                    "managerIdx": 401,
                    "createdTime": "2024-04-11T06:33:54.000Z",
                    "updatedTime": "2024-04-11T06:33:54.000Z",
                    "deletedTime": null
                }
            },
            {
                "idx": 512,
                "name": "유혜인",
                "code": "80013",
                "companyIdx": 100002,
                "companyManagerPerson": {
                    "idx": 15057,
                    "companyIdx": null,
                    "taxpayerIdx": 7562,
                    "companyManagerIdx": 3161,
                    "level": 2,
                    "managerIdx": 512,
                    "createdTime": "2024-04-11T06:33:54.000Z",
                    "updatedTime": "2024-04-11T06:33:54.000Z",
                    "deletedTime": null
                }
            }
        ]
    },

    {
        "cmpNo": "10437692860",
        "cmpName": "한신빌딩"
    },
    {
        "cmpNo": "10587416510",
        "cmpName": "주식회사다올시스"
    },
    {
        "cmpNo": "10587987940",
        "cmpName": "주식회사스탠다드에이"
    },
    {
        "cmpNo": "10686783390",
        "cmpName": "（주）일등유통"
    },
    {
        "cmpNo": "10687109040",
        "cmpName": "주식회사다나통상"
    },
    {
        "cmpNo": "10787545070",
        "cmpName": "（주）알토디자인"
    },
    {
        "cmpNo": "11293021660",
        "cmpName": "백송이전문점"
    },
    {
        "cmpNo": "11864004340",
        "cmpName": "더케이(The-K)웨딩컨벤션부페"
    },
    {
        "cmpNo": "11987050660",
        "cmpName": "（주）옴니텍"
    },
    {
        "cmpNo": "12386281160",
        "cmpName": "주식회사에스이테크"
    },
    {
        "cmpNo": "12686798030",
        "cmpName": "주식회사　부광물산"
    },
    {
        "cmpNo": "12786369040",
        "cmpName": "（주）대성팩"
    },
    {
        "cmpNo": "12986560410",
        "cmpName": "주식회사여산에프엔비"
    },
    {
        "cmpNo": "13802310300",
        "cmpName": "훈서비스"
    },
    {
        "cmpNo": "13813107820",
        "cmpName": "키네스평촌점"
    },
    {
        "cmpNo": "13881899490",
        "cmpName": "오비스텍주식회사"
    },
    {
        "cmpNo": "13891411150",
        "cmpName": "한국인성플러스연구소"
    },
    {
        "cmpNo": "14207254680",
        "cmpName": "신아트엔터테인먼트"
    },
    {
        "cmpNo": "14281467450",
        "cmpName": "（주）하성"
    },
    {
        "cmpNo": "14281841090",
        "cmpName": "주식회사명진하우징"
    },
    {
        "cmpNo": "14481305400",
        "cmpName": "이형종합건설 주식회사"
    },
    {
        "cmpNo": "15281026090",
        "cmpName": "주식회사웨이브도넛"
    },
    {
        "cmpNo": "20486203870",
        "cmpName": "（주）이래건축사사무소"
    },
    {
        "cmpNo": "22010072510",
        "cmpName": "라윤코리아"
    },
    {
        "cmpNo": "22486020590",
        "cmpName": "주식회사비전메디(VisionMediCo.,Ltd.)"
    },
    {
        "cmpNo": "22488014280",
        "cmpName": "주식회사플러스씨"
    },
    {
        "cmpNo": "22881066350",
        "cmpName": "주식회사 유닛랩"
    },
    {
        "cmpNo": "26181221890",
        "cmpName": "주식회사 시작바이이명순"
    },
    {
        "cmpNo": "29085004110",
        "cmpName": "단비코리아"
    },
    {
        "cmpNo": "30386022020",
        "cmpName": "주식회사티미"
    },
    {
        "cmpNo": "31888022270",
        "cmpName": "주식회사베이지안웍스"
    },
    {
        "cmpNo": "32988011880",
        "cmpName": "(주)티뮤스토리"
    },
    {
        "cmpNo": "33486021090",
        "cmpName": "로우리트콜렉티브주식회사"
    },
    {
        "cmpNo": "35186015560",
        "cmpName": "(주)더블유엔피"
    },
    {
        "cmpNo": "43686008050",
        "cmpName": "(주)삼에스테크"
    },
    {
        "cmpNo": "45288001400",
        "cmpName": "주식회사 페이지터너"
    },
    {
        "cmpNo": "46988008330",
        "cmpName": "주식회사휴웰"
    },
    {
        "cmpNo": "47687007220",
        "cmpName": "주식회사 알파랩"
    },
    {
        "cmpNo": "50687027680",
        "cmpName": "주식회사 그리머"
    },
    {
        "cmpNo": "50688018630",
        "cmpName": "주식회사 파이솔루션"
    },
    {
        "cmpNo": "50985025690",
        "cmpName": "주식회사 여산에프엔비"
    },
    {
        "cmpNo": "51885026370",
        "cmpName": "락앤볼1"
    },
    {
        "cmpNo": "59088009090",
        "cmpName": "태강산업개발(주)"
    },
    {
        "cmpNo": "60486019210",
        "cmpName": "불가리안로즈코리아주식회사"
    },
    {
        "cmpNo": "60988000660",
        "cmpName": "주식회사부국물산"
    },
    {
        "cmpNo": "65786008480",
        "cmpName": "주식회사해움시스템"
    },
    {
        "cmpNo": "67533012330",
        "cmpName": "미카도스시 영통점"
    },
    {
        "cmpNo": "67686013430",
        "cmpName": "케이민그룹 주식회사 (KMIN GROUP Corp.)"
    },
    {
        "cmpNo": "69001025260",
        "cmpName": "엠씨몰더이진점"
    },
    {
        "cmpNo": "70494002270",
        "cmpName": "신미리샌드아트학원"
    },
    {
        "cmpNo": "71021007380",
        "cmpName": "베초이(BECHOIS)"
    },
    {
        "cmpNo": "72999012490",
        "cmpName": "백송이전문점"
    },
    {
        "cmpNo": "74486015010",
        "cmpName": "주식회사리디아아트앤센트"
    },
    {
        "cmpNo": "75488015210",
        "cmpName": "엠케이청효주식회사"
    },
    {
        "cmpNo": "76187025400",
        "cmpName": "노몰로스주식회사"
    },
    {
        "cmpNo": "77802028800",
        "cmpName": "리휴"
    },
    {
        "cmpNo": "78181002100",
        "cmpName": "(주)단비코리아"
    },
    {
        "cmpNo": "81287027560",
        "cmpName": "주식회사올바른생각"
    },
    {
        "cmpNo": "82388021080",
        "cmpName": "주식회사훈미디어"
    },
    {
        "cmpNo": "89481011690",
        "cmpName": "제이핏주식회사"
    },
    {
        "cmpNo": "92022649011",
        "cmpName": "예쁜가방쌈지"
    },
    {
        "cmpNo": "92229169181",
        "cmpName": "(주)부광물산(PlayZonePC)"
    },
    {
        "cmpNo": "92336261311",
        "cmpName": "엠씨몰 대야점"
    }
].map((company) => ({
    idx: company.idx || company.cmpNo?.slice(0, 10),
    companyName: company.companyName || company.cmpName,
    bsno: company.bsno || company.cmpNo?.slice(0, 10),
    ...company
}));